import React from 'react';
import { Button, ButtonProps, Icon } from 'semantic-ui-react';

const SiderTrigger: React.FC<ButtonProps> = (props) => {
  return (
    <Button icon className="sider-trigger" color="purple" {...props}>
      <Icon name="tasks" />
    </Button>
  );
};

export default SiderTrigger;
